import pickby from 'lodash/pickBy';

const ORDERS_UI_EVENT_TYPE = 'orders-ui-event';
const ORDERS_UI_ERROR_TYPE = 'orders-ui-error';

type eventProps = {
  eventName?: string;
  debug?: boolean;
  [key: string]: any;
};

export const sanitizeError = (error: object): object =>
  pickby(error, (_, key) => key !== 'config' && key !== 'headers');

/**
 * Format event tracking data suitable for viewing in New Relic.
 * Spread Operator Usage: New Relic prefers flattened structure of data, nesting JSON will make querying difficult.
 * @param {string} eventReason queriable event type. Function will prepend ${ORDERS_UI_EVENT_TYPE} to the eventReason
 * @param {string} shopperId shopper ID of original request
 * @param {object} eventDataObj event data object
 */
export const createTrackingEventData = (
  eventReason: string,
  shopperId: string,
  eventDataObj: object = {}
): eventProps => ({
  eventName: ORDERS_UI_EVENT_TYPE,
  eventReason: `${ORDERS_UI_EVENT_TYPE}.${eventReason}`,
  shopper_id: shopperId,
  ...eventDataObj,
});

/**
 * Format error tracking data suitable for viewing in New Relic.
 * @param {string} errorReason queriable error type. Will prepend the ${ORDERS_UI_ERROR_TYPE} to the errorReason
 * @param {object} errorObj error data object
 * @param {string} shopperId shopper ID of original request
 * @param {object} additionalData additional data to be included on the event
 */
export const createTrackingErrorData = (
  errorReason: string,
  errorObj: object,
  shopperId: string,
  additionalData: object = {}
): eventProps => ({
  eventName: ORDERS_UI_ERROR_TYPE,
  errorReason: `${ORDERS_UI_ERROR_TYPE}.${errorReason}`,
  error: JSON.stringify(errorObj),
  shopper_id: shopperId,
  ...additionalData,
});
